var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 16C6 10.477 10.477 6 16 6C21.5228 6 25.9997 10.4766 26 15.9995C25.994 21.5194 21.52 25.994 16 26C10.4772 25.9997 6 21.5228 6 16ZM16 8C14.4178 8 12.8711 8.4692 11.5555 9.34824C10.2399 10.2273 9.21447 11.4767 8.60896 12.9385C8.00346 14.4004 7.84504 16.0088 8.15372 17.5608C8.4624 19.1126 9.22433 20.5381 10.3431 21.6568C11.4619 22.7757 12.8874 23.5376 14.4392 23.8463C15.9912 24.1549 17.5996 23.9965 19.0615 23.3911C20.5233 22.7855 21.7727 21.7602 22.6518 20.4445C23.5308 19.129 24 17.5822 24 16C23.9976 13.879 23.154 11.8455 21.6542 10.3458C20.1546 8.84608 18.1209 8.00246 16 8ZM15 11H17V15H21V17H15V11Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlan);
export default __webpack_public_path__ + "static/media/plan.bdd52081.svg";
export { ForwardRef as ReactComponent };